import api from './api'

/**
 * Bank Account Service
 * Handles all bank account-related API calls
 */
class BankAccountService {
  /**
   * Get all bank accounts for a club
   * GET v1/{club}/bank-accounts
   */
  async getBankAccounts(clubUuid: string): Promise<any> {
    const response = await api.get(`v1/${clubUuid}/bank-accounts`)
    return response.data
  }
}

export default new BankAccountService()
